import * as Yup from "yup";
import { AnyObject, Maybe } from "yup/lib/types";
import { isValidDate, isPastDate, isFutureDate, isOfLegalAge, isWithinPastYears, isDateAvailable, isNotFutureDate } from "@common/date";

// Yup instance which adds custom validation functions to the StringSchema

Yup.addMethod<Yup.StringSchema>(Yup.string, "isDateAvailable", function (errorMessage: string) {
  return this.test("is-date-available", errorMessage, (value) => isDateAvailable(value));
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "isValidDate", function (errorMessage: string) {
  return this.test("is-valid-date", errorMessage, (value) => isValidDate(value));
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "isPastDate", function (errorMessage: string) {
  return this.test("is-past-date", errorMessage, (value) => isPastDate(value));
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "isFutureDate", function (errorMessage: string) {
  return this.test("is-future-date", errorMessage, (value) => isFutureDate(value));
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "isNotFutureDate", function (errorMessage: string) {
  return this.test("is-not-future-date", errorMessage, (value) => isNotFutureDate(value));
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "isOfLegalAge", function (errorMessage: string) {
  return this.test("is-of-legal-age", errorMessage, (value) => isOfLegalAge(value));
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "isWithinPastYears", function (years: number, errorMessage: string) {
  return this.test("is-within-past-years", errorMessage, (value) => isWithinPastYears(years, true, value));
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "equalsValue", function (valueToEqual: string, errorMessage: string) {
  return this.test("equals-value", errorMessage, (value) => value === valueToEqual);
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "notEqualsValue", function (valueToNotEqual: string, errorMessage: string) {
  return this.test("not-equals-value", errorMessage, (value) => value !== valueToNotEqual);
});

declare module "yup" {
  interface StringSchema<TType extends Maybe<string> = string | undefined, TContext extends AnyObject = AnyObject, TOut extends TType = TType> extends Yup.BaseSchema<TType, TContext, TOut> {
    isDateAvailable(errorMessage: string): StringSchema<TType, TContext>;
    isValidDate(errorMessage: string): StringSchema<TType, TContext>;
    isPastDate(errorMessage: string): StringSchema<TType, TContext>;
    isFutureDate(errorMessage: string): StringSchema<TType, TContext>;
    isNotFutureDate(errorMessage: string): StringSchema<TType, TContext>;
    isOfLegalAge(errorMessage: string): StringSchema<TType, TContext>;
    isWithinPastYears(years: number, errorMessage: string): StringSchema<TType, TContext>;
    isValidTaxIdentificationNumber(errorMessage: string): StringSchema<TType, TContext>;
    isValidIban(errorMessage: string): StringSchema<TType, TContext>;
    equalsValue(value: string, errorMessage: string): StringSchema<TType, TContext>;
    notEqualsValue(value: string, errorMessage: string): StringSchema<TType, TContext>;
    hasValidAmountValue(minValue: number, maxValue: number, errorMessage: string): StringSchema<TType, TContext>;
    hasValidMinAmountValue(minValue: number, errorMessage: string): StringSchema<TType, TContext>;
    hasValidMaxAmountValue(maxValue: number, errorMessage: string): StringSchema<TType, TContext>;
    hasValidMobileNumberLength(errorMessage: string): StringSchema<TType, TContext>;
    notMobileNumberWithLeftZeros(errorMessage: string): StringSchema<TType, TContext>;
  }
}

export { Yup };
